import { StoreBadges } from '../components/StoreBadges';
import { Eyebrow, Footer, GetAppBar, KindTag, TopBar } from '../components/Site';
import changelog from '../content/changelog.json';
import { usePageMeta } from '../lib/meta';

type Kind = 'new' | 'improved' | 'fixed';

/** "2026-09" → "September 2026". */
function monthLabel(ym: string) {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function Changelog() {
  usePageMeta(
    'Changelog — what’s new in shotmeal',
    'Every shotmeal release: weight progress with Apple Health and Health Connect, nutrients from every photo, household diaries, favorites and more.',
  );
  return (
    <main class="page-in">
      <TopBar />
      <section style={{ padding: '56px 0 24px' }}>
        <div class="container" style={{ maxWidth: 860 }}>
          <Eyebrow>Changelog</Eyebrow>
          <h1
            class="wordmark"
            style={{
              margin: '12px 0 0',
              fontSize: 'clamp(44px, 7vw, 76px)',
              lineHeight: 0.98,
              letterSpacing: '-0.03em',
              color: 'var(--ink)',
            }}
          >
            What's new in <span class="accent">shotmeal.</span>
          </h1>
          <p style={{ color: 'var(--ink-2)', fontSize: 17, lineHeight: 1.55, maxWidth: 560, marginTop: 16 }}>
            Every release, newest first. Update from the App Store or Google
            Play to get the latest.
          </p>
        </div>
      </section>

      <section style={{ padding: '8px 0 64px' }}>
        <div class="container changelog" style={{ maxWidth: 860 }}>
          {changelog.releases.map((r, i) => (
            <article key={r.version} id={`v${r.version}`} class="release">
              <div class="release-rail">
                <div class="release-version wordmark">{r.version}</div>
                <div class="release-date">{monthLabel(r.date)}</div>
                {i === 0 && <span class="release-latest">Latest</span>}
              </div>
              <div class="release-body">
                <h2 class="wordmark release-title">{r.title}.</h2>
                <p class="release-summary">{r.summary}</p>
                <div class="release-highlights">
                  {r.highlights.map((h) => (
                    <div key={h.title} class="release-card">
                      <KindTag kind={h.kind as Kind} />
                      <h3 class="wordmark">{h.title}</h3>
                      <p>{h.text}</p>
                    </div>
                  ))}
                </div>
                {r.more.length > 0 && (
                  <ul class="release-more">
                    {r.more.map((m) => (
                      <li key={m.text}>
                        <KindTag kind={m.kind as Kind} />
                        <span>{m.text}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </article>
          ))}
          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <div style={{ display: 'inline-block' }}>
              <StoreBadges />
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <GetAppBar />
    </main>
  );
}
